import React from 'react';
import { useNavigate } from 'react-router-dom';
import HashtagDisplay from './HashtagDisplay';
import PoliticalLeaningBadge from './PoliticalLeaningBadge';
import PasswordProtection from './PasswordProtection';

const AgendaItem = ({ item, isSelected, onClick, onSummaryClick, onHashtagClick }) => {
  const navigate = useNavigate();
  
  // Wrapper function for password protection that doesn't require an event
  const handleSummaryClickProtected = () => {
    onSummaryClick(item);
  };

  return (
    <div 
      className={`p-4 px-5 border-b border-gray-200 dark:border-gray-700 transition hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer ${isSelected ? 'bg-primary/10 dark:bg-primary/20 border-l-3 border-primary' : ''}`}
      onClick={onClick}
    >
      <div className="flex flex-col">
        <div className="flex items-start mb-2">
          <div className="inline-flex items-center justify-center w-8 h-8 bg-primary text-white text-xs font-medium rounded-full uppercase tracking-wider mr-3">
            {item.item_number}
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <h3 className="font-medium text-gray-900 dark:text-white">{item.title}</h3>
              <PoliticalLeaningBadge leaningScore={item.leaning_score} />
            </div>
            {item.description && (
              <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">{item.description}</p>
            )}
            <HashtagDisplay 
              hashtags={item.hashtags} 
              className="mt-2 mb-2" 
              onHashtagClick={onHashtagClick}
            />
          </div>
        </div>
        <div className="ml-11 flex gap-2">
          <button 
            className="inline-flex items-center justify-center py-2 px-4 text-sm font-medium rounded border-0 cursor-pointer transition gap-2 bg-primary text-white hover:bg-primary-dark hover:-translate-y-0.5 hover:shadow"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/speeches/${item.id}`);
            }}
          >
            <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
            </svg>
            View Speeches
          </button>
          <PasswordProtection onAuthenticated={handleSummaryClickProtected}>
            <button 
              className="inline-flex items-center justify-center py-2 px-4 text-sm font-medium rounded border-0 cursor-pointer transition gap-2 bg-secondary text-white hover:bg-secondary-dark hover:-translate-y-0.5 hover:shadow"
              onClick={(e) => {
                //e.stopPropagation();
              }}
            >
              <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
              Summary
            </button>
          </PasswordProtection>
        </div>
      </div>
    </div>
  );
};

export default AgendaItem;
